import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'GET_CATEGORIES_FORM_BY_USERTYPE': {
			return {
				...state,
				entities: action.payload,
			}
		}
		default:
			state = crudHandlers(state, action, 'category_form')

			return state
	}
}
